let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iX3CG")).then(() => parcelRequire('f34NH'));